/** @file Resolves a name or id reference of an entity kind to its id using the document index. */
import type { DocIndex, EntityKind, Id } from '@pose2d/format/types';
import { ids } from '@pose2d/format/ids';
import { throwError } from '@pose2d/format/throwError';

/** Accepts an id (validated to exist and be of `kind`) or a unique name within `kind`. */
export function resolveRef(index: DocIndex, kind: EntityKind, ref: string): Id {
  if (ids.isId(ref)) {
    if (index.kindOf.get(ref) === kind) return ref;
  } else {
    const id = index.byName.get(kind)?.get(ref);
    if (id) return id;
  }
  return throwError('NOT_FOUND', { kind, ref }, { hint: 'use get_summary to list names' });
}
